import { defineStore } from 'pinia'
import { authFetch, getErrorMessage } from '../services/http'

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export type SystemSettings = {
  id: string
  subdivision: string
  barangay: string
  city?: string | null
  province?: string | null
  codePrefix: string
  monthlyDues: number
  householdTypePricingEnabled: boolean
  billingDueDay: number
  billingAutoIncludeVacant: boolean
  visitorRequestExpiryMinutes: number
  communityType?: 'SUBDIVISION' | 'CONDOMINIUM'
  duesRatePerSqm?: number | null
}

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    data: null as SystemSettings | null,
    loading: false,
    error: null as string | null,
  }),
  actions: {
    async get() {
      this.loading = true
      this.error = null
      try {
        const response = await authFetch(`${apiBaseUrl}/settings`)
        if (!response.ok) {
          const message = await getErrorMessage(response, 'Failed to load settings')
          throw new Error(message)
        }
        this.data = await response.json()
      } catch (error) {
        this.error = error instanceof Error ? error.message : 'Failed to load settings'
        throw error
      } finally {
        this.loading = false
      }
    },

    async update(payload: Partial<SystemSettings>) {
      this.loading = true
      this.error = null
      try {
        const response = await authFetch(`${apiBaseUrl}/settings`, {
          method: 'PATCH',
          body: JSON.stringify(payload),
        })
        if (!response.ok) {
          const message = await getErrorMessage(response, 'Failed to update settings')
          throw new Error(message)
        }
        this.data = await response.json()
        return this.data
      } catch (error) {
        this.error = error instanceof Error ? error.message : 'Failed to update settings'
        throw error
      } finally {
        this.loading = false
      }
    },
  },
})
